import React, { useEffect, useState } from "react";

export default function LeaderboardScreen({ game }) {
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [selectedSet, setSelectedSet] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    game.fetchLeaderboard().finally(() => setLoading(false));
  }, []);

  const medals = ["🥇", "🥈", "🥉"];

  const levels = [...new Set(game.leaderboard.map((x) => x.level))];

  const sets = [
    ...new Set(
      game.leaderboard
        .filter((x) => x.level === selectedLevel)
        .map((x) => x.set),
    ),
  ];

  const filteredData = game.leaderboard.filter(
    (x) => x.level === selectedLevel && x.set === selectedSet,
  );

  return (
    <div className="min-h-screen flex flex-col relative z-10 border-y-2 border-pink-400 rounded-xl">
      <div className="flex items-center justify-between px-5 py-1 border-b border-white/10">
        <button
          onClick={() => game.setScreen("home")}
          className="text-violet-400 w-fit px-2 py-1 font-medium flex items-center gap-1"
        >
          ← Back
        </button>
        <h2 className="text-xl font-bold">Leaderboard</h2>
        <div className="w-8" />
      </div>

      <div className="px-3 py-2 border-b border-white/10">
        <div className="flex gap-2 overflow-x-auto pb-2">
          {levels.map((level) => (
            <button
              key={level}
              onClick={() => {
                setSelectedLevel(level);
                const s = [
                  ...new Set(
                    game.leaderboard
                      .filter((x) => x.level === level)
                      .map((x) => x.set),
                  ),
                ][0];
                setSelectedSet(s);
              }}
              className={`w-fit px-2 py-1 rounded-md whitespace-nowrap text-xs lg:text-sm font-semibold transition
                ${
                  selectedLevel === level
                    ? "bg-violet-500 text-white"
                    : "bg-[#221540] border border-white/10"
                }`}
            >
              Level {level}
            </button>
          ))}
        </div>
        <div className="flex gap-2 overflow-x-auto">
          {sets.map((set) => (
            <button
              key={set}
              onClick={() => setSelectedSet(set)}
              className={`w-fit px-2 py-1 rounded-md whitespace-nowrap text-[11px] lg:text-[14px] font-semibold transition
                ${
                  selectedSet === set
                    ? "bg-cyan-500 text-black"
                    : "bg-[#221540] border border-white/10"
                }`}
            >
              {set}
            </button>
          ))}
        </div>
      </div>

      <div className="flex-1 overflow-auto px-4 py-2">
        {loading ? (
          <div className="text-center py-10 text-zinc-200">Loading...</div>
        ) : game.leaderboard.length === 0 ? (
          <div className="text-center py-10 text-zinc-100">
            No leaderboard data yet. Be the first! 👑
          </div>
        ) : (
          <div className="space-y-1">
            {filteredData.map((entry, i) => (
              <div
                key={entry.userId || i}
                className={`flex items-center gap-4 bg-[#221540] border rounded-2xl px-4 py-1 ${i < 3 ? "border-yellow-400/30" : "border-white/10"}`}
              >
                <div className="w-8 text-2xl font-mono text-center">
                  {i < 3 ? medals[i] : `#${entry.rank}`}
                </div>

                <div className="w-11 h-11 rounded-full bg-violet-500/20 flex items-center justify-center overflow-hidden flex-shrink-0">
                  {entry.avatar ? (
                    <img
                      src={entry.avatar}
                      alt={entry.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <span className="text-violet-300 font-bold">
                      {(entry.name || "?").charAt(0).toUpperCase()}
                    </span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="font-semibold truncate">
                    {entry.name || "Anonymous"}
                  </div>
                  <div className="text-xs text-zinc-200">
                    L${entry.level} • ${entry.set}
                  </div>
                  <div className="text-[10px] text-cyan-300">
                    {(Number(entry.timeTaken) / 1000).toFixed(2)} sec
                  </div>
                </div>

                <div className="font-mono text-xl font-bold text-violet-300">
                  {entry.iqScore}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
